import type { ListBuilderList } from '../../../types';

/**
 * Superseded Permit (PD-16228) — one of the quality classes the tenant value ledger
 * publishes (scripts/license-management/maintenance/active/tenant-value-ledger.mjs),
 * now a list a reviewer can act on instead of a number in a CLI report.
 *
 * The account holds a lapsed licence while the board shows a DIFFERENT active permit of the same kind in the same state for that client. Republic, 2026-09-17: 74 licences — the same number the value ledger reports.
 *
 * Backed by the locked `licenseRegistryGap: superseded` filter, which reads the
 * registry's own row through the licence's confirmed link OR through an
 * unconfirmed licence-number suggestion at 90%+ — the same rule as the Not
 * Usable card (PD-16225), because Tier-1 auto-confirm refuses to confirm onto a
 * row that disagrees with the licence on file, so waiting for a link would hide
 * the case entirely.
 *
 * Last sale newest first: the actively-buying account is the one to fix first.
 */
export const supersededPermitList: ListBuilderList = {
	id: 'default-licenses-superseded',
	cacheTTL: 300000,
	name: 'Superseded Permit',
	type: 'default',
	active: true,
	sortOrder: 13,
	filterRules: {
		licenseRegistryGap: {
			defaultValue: [{ id: 'superseded', label: 'Superseded Permit' }],
			locked: true,
			hidden: true,
		},
		licenseSalesRep: {
			defaultValue: [{ id: 'ME', label: 'Me' }],
			applyDefaultIf: {
				type: 'group',
				joiner: 'AND',
				negated: false,
				children: [
					{ type: 'rule', action: 'licenses:view:any', negated: true },
				],
			},
			lockedIf: {
				type: 'group',
				joiner: 'AND',
				negated: false,
				children: [
					{ type: 'rule', action: 'licenses:view:any', negated: true },
				],
			},
			hiddenIf: {
				type: 'group',
				joiner: 'AND',
				negated: false,
				children: [
					{ type: 'rule', action: 'licenses:view:any', negated: true },
				],
			},
		},
	},
	defaultSortId: 'recent-sale-desc',
	inheritsFrom: 'default-licenses-all',
};
